import { applyMiddleware, combineReducers, createStore } from 'redux';
import {
  countDownSecondsToOpenMarket,
  fetchAllCoveredWarrant,
  fetchEconomy,
  fetchUserWatchlist,
  getTimeOffset,
} from './commonReducer';
import reducers from './reducer';
import thunk from 'redux-thunk';
import {
  loadTranslations,
  setLocale,
  syncTranslationWithStore,
} from 'react-redux-i18n';
import i18n from '../lang/i18n';
import { composeWithDevTools } from 'redux-devtools-extension';
import {
  fetchOrganization,
  fetchCompanyGroup,
  fetchIndustry,
  fetchDerivative,
} from './commonReducer';
import reducerRegistry from '../helpers/ReducerRegistry';
import { getLanguage, changeUILanguage } from './../helpers/Language';
import authProvider from '../../core/AuthenticationProvider';
import {
  fetchDataSystemSetting,
  fetchDataUserInfo,
} from './../main-layout/sidebar/reducer';
import LayoutHelper from '../helpers/Layout';
import { nameSaveStateDefault } from '../../configs/LayoutConfig';
import currentState from '../helpers/CurrentState';
import { getTheme, changeUITheme } from './../helpers/Theme';
import { getFontSize, changeUIFontSize } from './../helpers/FontSize';

const store = createStore(
  reducers,
  composeWithDevTools(applyMiddleware(thunk)),
);

// Replace the store's reducer whenever a new reducer is registered.
reducerRegistry.setChangeListener(reducers => {
  store.replaceReducer(combineReducers(reducers));
});

syncTranslationWithStore(store);
store.dispatch(setLocale(getLanguage()));
store.dispatch(loadTranslations(i18n));

store.dispatch(fetchOrganization());
store.dispatch(fetchAllCoveredWarrant());
store.dispatch(fetchCompanyGroup());
store.dispatch(fetchIndustry());
store.dispatch(fetchDerivative());
store.dispatch(fetchEconomy());
store.dispatch(countDownSecondsToOpenMarket());
authProvider.getUser().then(user => {
  if (user && !user.expired) {
    store.dispatch(fetchDataSystemSetting());

    store.dispatch(getTimeOffset());

    store.dispatch(fetchDataUserInfo(user));
    store.dispatch(fetchUserWatchlist());
  }
});

const savedState = LayoutHelper.getState(nameSaveStateDefault);
if (savedState !== null) {
  currentState.apply(JSON.parse(savedState).data);
}

changeUITheme(getTheme());
changeUIFontSize(getFontSize());
changeUILanguage(getLanguage());

export default store;
